import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';

import { termsByLang } from 'src/assets/i18n/terms/terms_index';
@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    standalone: false
})
export class TermsComponent implements OnInit {

  @Input() language: string = 'es';
  termsText: string = '';
  currentLang: any;

  constructor(public activeModal: NgbActiveModal, private _translate: TranslateService, private location: Location) { }


  ngOnInit(): void {

    this.termsText = termsByLang[this.language] || termsByLang['es'];
    if (!this.language)
      this.language =  'es';

    this.currentLang = this._translate.currentLang || this._translate.getDefaultLang();
    this.termsText = termsByLang[this.currentLang]

  }

  // Si se quiere usar en modal
  closeModal() {
    this.activeModal.close();
  }

  close(){
      this.location.back();
  }

}
